import * as Yup from 'yup';

export default Yup.object().shape({
  message: Yup.string()
    .required('Il campo è obbligatorio'),
});
